import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthJwtService } from '../services/auth-jwt.service';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = () => {
  if (environment.useSSO) return true;

  const jwtService = inject(AuthJwtService);
  const router = inject(Router);

  if (!jwtService.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};
